import { render, staticRenderFns } from "./BookScopeSelect.vue?vue&type=template&id=31d72e61&"
import script from "./BookScopeSelect.vue?vue&type=script&lang=js&"
export * from "./BookScopeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports